import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { ContextualMenuItem } from './types';
import { useAdjustedFontSize } from '../../hooks/useAdjustedFontSize';
import { CustomIcon } from '../CustomIcon';
import CustomText from '../CustomText';

interface ContextualMenuListItemProps {
  item: ContextualMenuItem;
  onPress?: () => void;
  onRequestClose?: () => void;
}

export const ContextualMenuListItem: React.FC<ContextualMenuListItemProps> = ({
  item,
  onPress,
  onRequestClose,
}) => {
  const fontSize = useAdjustedFontSize(mvs(16));

  const handlePress = () => {
    if (item.disabled) {
      return;
    }
    if (onPress) {
      onPress();
    } else {
      item.onPress();
    }
    onRequestClose?.();
  };

  return (
    <TouchableOpacity
      style={[styles.container, item.disabled && styles.disabled]}
      onPress={handlePress}
      activeOpacity={item.disabled ? 1 : 0.7}
      disabled={item.disabled}
    >
      {item.icon && (
        <View style={styles.iconContainer}>
          <CustomIcon name={item.icon} size={mvs(16)} style={styles.icon} />
        </View>
      )}
      <CustomText style={[styles.text, { fontSize }]} numberOfLines={1}>
        {item.title}
      </CustomText>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: mvs(12),
  },
  disabled: {
    opacity: 0.4,
  },
  iconContainer: {
    minWidth: mvs(24),
    backgroundColor: 'transparent',
  },
  icon: {
    opacity: 0.5,
  },
  text: {
    flex: 1,
  },
});
